import { Link, useNavigate } from "react-router-dom";
import { use, useEffect, useState } from "react";


import { useContactType } from "../../contexts/ContactContext";
import { routesMap } from "../../constants/routes";




export const CheckoutPage = () => {


    const {contact,cart,family} = useContactType()

    const productId = cart[0]?.product
     const navigate = useNavigate()
    
    
     useEffect(() => {
      if(!productId){
        navigate(routesMap.checkoutChoosePlan.to)
      } else if(!contact){
        navigate(routesMap.checkoutReg.to)
      } else if(!contact?.payments0__Gov_Id || !contact?.Date_of_Birth){
        navigate(routesMap.checkoutAddtionalInfo.to)
      } else if(family===null){
        navigate(routesMap.checkoutFamily.to)
      } else {
        navigate(routesMap.checkoutPayment.to)
      }
     },[])
    

    return null
}